module.exports = __webpack_public_path__ + "static/media/vi.e2ccb9c0.svg";